const views = {
  MAP: "map",
  TABLE: "table",
  COMPARE: "compare",
};

const states = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const StateAbbrv = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Puerto Rico": "PI",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  "Virgin Islands": "VI",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

const TableColumns = {
  HOSPITAL_NAME: "Hospital Name",
  SLIDER: "slider",
  SHARE: "share",
  BOOKMARK: "bookmark",
  LOCATION: "location",
  OWNERSHIP_TYPE: "ownership type",
  NO_OF_BEDS: "no. of beds.",
  PATIENT_DISCHARGES: "patient discharges",
  NET_PATIENT_REVENUE: "net patient revenue",
  ACCREDITATIONS: "Accreditations",
  CMS_RATINGS: "cms ratings",
  RANKING: "ranking",
  SCORE: "score",
};

const columnsWithSortIcon = [
  "Hospital Name",
  "Location",
  "Ownership Type",
  "No. of Beds.",
  "Patient Discharges",
  "Net Patient Revenue",
  "Accreditations",
  "Overall Rating",
  "Ranking",
  "Score"
];

const Filters = {
  LOCATION: "Location",
  FACILITIES: "Facilities",
  ONCOLOGY_FOCUS: "Oncology Focus",
  FINANCIAL_AND_OPERATIONAL: "Financial & Operational",
  REPUTATION: "Reputation",
  AFFILIATIONS: "Affiliations",
  ACCREDITATIONS: "Accreditations",
  QUALITY_OF_CARE: "Quality of Care",
  PATIENT_EXPERIENCE: "Patient Experience",
  ACCESSIBILITY_AND_INCLUSIVITY: "Accessibility & Inclusivity",
  SEARCH_HISTORY: "Search History",
};

const HospitalsOptions = [
  {
    value: "IOWA METHODIST MEDICAL CENTER",
    label: "IOWA METHODIST MEDICAL CENTER",
    location: "DES MOINES, IA",
    provider_number: 160082,
  },
  {
    value: "ST. JOSEPHS MEDICAL CENTER",
    label: "ST. JOSEPHS MEDICAL CENTER",
    location: "1800 N. CALIFORNIA STREET",
    provider_number: 50084,
  },
  {
    value: "LOYOLA UNIVERSITY MEDICAL CENTER",
    label: "LOYOLA UNIVERSITY MEDICAL CENTER",
    location: "MAYWOOD, IL",
    provider_number: 140276,
  },
  {
    value: "ASCENSION SE WISCONSIN HOSPITAL INC",
    label: "ASCENSION SE WISCONSIN HOSPITAL INC",
    location: "MILWAUKEE, WI",
    provider_number: 520136,
  },
  {
    value: "NORTHWESTERN LAKE FOREST HOSPITAL",
    label: "NORTHWESTERN LAKE FOREST HOSPITAL",
    location: "1000 WESTMORELAND ROAD",
    provider_number: 140130,
  },
  {
    value: "OU MEDICAL CENTER",
    label: "OU MEDICAL CENTER",
    location: "OKLAHOMA CITY, OK",
    provider_number: 370093,
  },
  {
    value: "GOOD SAMARITAN HOSPITAL",
    label: "GOOD SAMARITAN HOSPITAL",
    location: "CINCINNATI, OH",
    provider_number: 360134,
  },
  {
    value: "AULTMAN HOSPITAL",
    label: "AULTMAN HOSPITAL",
    location: "CANTON, OH",
    provider_number: 360084,
  },
];

const exportOptions = [
  { value: "Download as CSV", label: "Download as CSV", type: "csv" },
  { value: "Download as XLSX", label: "Download as XLSX", type: "xlsx" },
  { value: "Download as JSON", label: "Download as JSON", type: "json" },
];

export {
  views,
  states,
  TableColumns,
  Filters,
  HospitalsOptions,
  exportOptions,
  StateAbbrv,
  columnsWithSortIcon,
};
